import React from "react";
import "../style/profile.css";

const ProfileField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  disabled,
  icon
}) => {
  return (
    <div className="profile-field">
      <label className="profile-label">
        {icon && <span className="field-icon">{icon}</span>}
        {label}
      </label>
      <input
        className="profile-input"
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default ProfileField;
